
import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

const values = [
  {
    icon: 'ri-focus-3-line',
    title: 'Precyzja',
    description:
      'Każdy element produkujemy z najwyższą dokładnością. Tolerancje na poziomie setnych milimetra to nasz standard.',
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Jakość',
    description:
      'Certyfikaty ISO, EN i UDT potwierdzają nasze standardy. Rygorystyczna kontrola na każdym etapie produkcji.',
  },
  {
    icon: 'ri-team-line',
    title: 'Doświadczenie',
    description:
      '35 lat na rynku i zespół 19 wykwalifikowanych specjalistów. Wiedza przekazywana z pokolenia na pokolenie.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Innowacja',
    description:
      'Inwestujemy w badania i rozwój. Projekt B+R mostka rowerowego to dowód naszego podejścia do innowacji.',
  },
];

export default function CompanyValues() {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  return (
    <section
      ref={ref}
      className="relative py-20 sm:py-32 bg-[#050505] overflow-hidden"
    >
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00E5FF]/20 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16 sm:mb-20"
        >
          <span
            className="text-[#00E5FF] text-xs tracking-[0.3em] uppercase font-semibold"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            Nasze Wartości
          </span>
          <h2
            className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mt-4 leading-tight"
            style={{ fontFamily: 'Rajdhani, sans-serif' }}
          >
            Fundamenty <span className="text-[#00E5FF]">Sukcesu</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((value, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7, delay: index * 0.12 }}
              className="group relative bg-[#111111] border border-[#1A1A1A] p-6 sm:p-8 hover:border-[#00E5FF]/50 transition-all duration-500 hover:-translate-y-1"
            >
              <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#00E5FF]/0 to-transparent group-hover:via-[#00E5FF] transition-all duration-500"></div>

              <div className="w-14 h-14 flex items-center justify-center bg-[#00E5FF]/5 border border-[#00E5FF]/20 mb-6 group-hover:bg-[#00E5FF]/10 group-hover:border-[#00E5FF]/50 transition-all duration-500">
                <i className={`${value.icon} text-2xl text-[#00E5FF]`}></i>
              </div>

              <h3
                className="text-lg font-bold text-white mb-3 leading-tight"
                style={{ fontFamily: 'Rajdhani, sans-serif' }}
              >
                {value.title}
              </h3>

              <p
                className="text-[#888] text-sm leading-relaxed group-hover:text-[#C0C7CF] transition-colors duration-300"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {value.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
